import { useMutation } from "@tanstack/react-query";

import { createUser } from "@services/user";

export const useCreateUser = (options: Record<string, any> = {}) => {
  return useMutation(createUser, {
    ...options,
  });
};
